import { createSelector } from "reselect";

const selectDepartment = (state) => state.departments;

export const departmentsLoading = createSelector(
  [selectDepartment],
  (department) => department.isLoading
);

export const selectIsCreatingDepartment = createSelector(
  [selectDepartment],
  (department) => department.isCreatingDepartment
);
export const selectIsEditingDepartment = createSelector(
  [selectDepartment],
  (department) => department.isEditingDepartment
);
export const selectIsDeletingDepartment = createSelector(
  [selectDepartment],
  (department) => department.isDeletingDepartment
);
export const selectDepartments = createSelector(
  [selectDepartment],
  (department) => department.departments
);
